import React, { useState } from 'react';
import '../../../entrydoor.css';

const HingesCoverColor = ({ value, onChange, label = 'Hinges Cover Color:', disabled = false }) => {
    const [selectedHingesCoverColor, setSelectedHingesCoverColor] = useState(value || "White");

    const handleHingesCoverColorChange = (e) => {
        setSelectedHingesCoverColor(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="HingesCoverColor">{label}</label>
            <select
                disabled={disabled}
                id="HingesCoverColor"
                value={selectedHingesCoverColor}
                onChange={handleHingesCoverColorChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="White">{selectedHingesCoverColor === "White" ? "White ✔" : "White"}</option>
                <option value="Black">{selectedHingesCoverColor === "Black" ? "Black ✔" : "Black"}</option>
                <option value="Titan">{selectedHingesCoverColor === "Titan" ? "Titan ✔" : "Titan"}</option>
                <option value="Brown">{selectedHingesCoverColor === "Brown" ? "Brown ✔" : "Brown"}</option>
                <option value="Gold" >{selectedHingesCoverColor === "Gold"  ? "Gold ✔"  : "Gold" }</option>
           </select>
        </div>
    );
};

export default HingesCoverColor;
